var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatCPF } from '../../App/utils/formatter';
import { Modal } from 'react-bootstrap';
function ConfirmAction(_a) {
    var _b, _c, _d;
    var show = _a.show, closeModal = _a.closeModal, actionType = _a.actionType, onConfirm = _a.onConfirm, _e = _a.isUpdate, isUpdate = _e === void 0 ? false : _e, _f = _a.productName, productName = _f === void 0 ? '' : _f, _g = _a.cpfList, cpfList = _g === void 0 ? [] : _g;
    var actionTitles = {
        ativar: 'Ativação',
        activate: 'Ativação',
        suspender: 'Suspensão',
        suspend: 'Suspensão',
        cancelar: 'Cancelamento',
        cancel: 'Cancelamento',
        reativar: 'Reativação',
        reactivate: 'Reativação',
        reenviar: 'Reenvio de e-mail',
        resend: 'Reenvio de e-mail',
    };
    var actionTexts = {
        ativar: 'ativação',
        activate: 'ativação',
        suspender: 'suspensão',
        suspend: 'suspensão',
        cancelar: 'cancelamento',
        cancel: 'cancelamento',
        reativar: 'reativação',
        reactivate: 'reativação',
        reenviar: 'reenvio de e-mail',
        resend: 'reenvio de e-mail',
    };
    var actionVerbs = {
        ativar: 'Ativar',
        activate: 'Ativar',
        suspender: 'Suspender',
        suspend: 'Suspender',
        cancelar: 'Cancelar',
        cancel: 'Cancelar',
        reativar: 'Reativar',
        reactivate: 'Reativar',
        reenviar: 'Reenviar',
        resend: 'Reenviar',
    };
    var title = isUpdate
        ? 'Confirmar mudanças'
        : "Confirmar ".concat(actionTitles[actionType] || actionType.charAt(0).toUpperCase() + actionType.slice(1));
    function renderCpfColumns() {
        if (!isUpdate || cpfList.length === 0)
            return null;
        var filteredCpfList = cpfList.filter(function (cpf) { return cpf.toUpperCase() !== 'CPF'; });
        return (_jsx("div", __assign({ style: { display: 'flex', flexWrap: 'wrap', gap: '1rem' } }, { children: filteredCpfList.map(function (cpf) { return (_jsx("div", __assign({ style: {
                    minWidth: '120px',
                    padding: '4px 8px',
                    textAlign: 'center',
                } }, { children: formatCPF(cpf) }), cpf)); }) })));
    }
    var isActivationAction = actionType === 'ativar' || actionType === 'activate';
    var isResendAction = actionType === 'reativar' || actionType === 'reactivate';
    return (_jsxs(Modal, __assign({}, { show: show, onHide: closeModal }, { "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "default-modal-styling" }, { children: [_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx("h3", { children: title }) })), _jsxs(Modal.Body, __assign({ style: { paddingBottom: '0' } }, { children: [isUpdate ? (_jsxs("p", { children: ["Voc\u00EA realmente deseja", ' ', _jsxs("span", __assign({ style: { color: 'blue', fontWeight: 'bold' } }, { children: [' ', ((_b = actionVerbs[actionType]) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
                                        actionType, ' ', productName] })), ' ', "para os assinantes listados abaixo?"] })) : isResendAction ? (_jsx("p", { children: "Tem certeza que deseja reativar o servi\u00E7o? Caso o assinante nunca tenha conclu\u00EDdo a ativa\u00E7\u00E3o do produto de streaming, ele receber\u00E1 um email para realizar esse processo." })) : isActivationAction ? (_jsxs("p", { children: ["Voc\u00EA tem certeza que deseja", ' ', _jsx("span", { children: ((_c = actionVerbs[actionType]) === null || _c === void 0 ? void 0 : _c.toLowerCase()) ||
                                    actionType }), ' ', "esse servi\u00E7o? Ao confirmar, voc\u00EA enviar\u00E1 um e-mail de", ' ', _jsx("span", { children: actionTexts[actionType] || actionType }), ' ', "para os endere\u00E7os cadastrados pelo assinante."] })) : (_jsxs("p", { children: ["Voc\u00EA tem certeza que deseja", ' ', _jsx("span", { children: ((_d = actionVerbs[actionType]) === null || _d === void 0 ? void 0 : _d.toLowerCase()) ||
                                    actionType }), ' ', "esse servi\u00E7o?"] })), renderCpfColumns()] })), _jsxs(Modal.Footer, { children: [_jsx("button", __assign({ id: "btn-confirm-action-cancel", onClick: closeModal, className: "button-with-blue-border", style: { width: 106, height: 36 } }, { children: "Cancelar" })), _jsx("button", __assign({ id: "btn-confirm-action-confirm", onClick: function () {
                            onConfirm();
                            closeModal();
                        }, className: "blue-button", style: { width: 106, height: 36 } }, { children: "Confirmar" }))] })] })));
}
export default ConfirmAction;
